import ENGLISH_WORDS from './english_words.json';
import SPANISH_WORDS from './spanish_words.json';
import RUSSIAN_WORDS from './russian_words.json';

export const arrayRange = (start, stop, step) =>
    Array.from(
        { length: (stop - start) / step + 1 },
        (value, index) => start + index * step
    );

export const sample = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)];
};

// export const checkGuess = (guess, answer) => {
//     let answerCopy = answer;
//     if (!guess) {
//         return null;
//     }
//     const result = guess.split('').map((letter, guessIndex) => {
//         if (letter === answerCopy[guessIndex]) {
//             answerCopy = filterUsedLetters(answerCopy, guessIndex);
//             return { letter: letter, status: 'correct' };
//         } else if (answerCopy.search(letter) !== -1) {
//             const index = answerCopy.indexOf(letter);
//             answerCopy = filterUsedLetters(answerCopy, index);
//             return { letter: letter, status: 'misplaced' };
//         }
//         return { status: 'incorrect', letter };
//     });
//     return result;
// };
export function checkGuess(guess, answer) {
    // This constant is a placeholder that indicates we've successfully
    // dealt with this character (it's correct, or misplaced).
    const SOLVED_CHAR = '✓';

    if (!guess) {
        return null;
    }

    const guessChars = guess.toUpperCase().split('');
    const answerChars = answer.toUpperCase().split('');

    const result = [];

    // Step 1: Look for correct letters.
    for (let i = 0; i < guessChars.length; i++) {
        if (guessChars[i] === answerChars[i]) {
            result[i] = {
                letter: guessChars[i],
                status: 'correct',
            };
            answerChars[i] = SOLVED_CHAR;
            guessChars[i] = SOLVED_CHAR;
        }
    }

    // Step 2: look for misplaced letters. If it's not misplaced,
    // it must be incorrect.
    for (let i = 0; i < guessChars.length; i++) {
        if (guessChars[i] === SOLVED_CHAR) {
            continue;
        }

        let status = 'incorrect';
        const misplacedIndex = answerChars.findIndex(
            (char) => char === guessChars[i]
        );
        if (misplacedIndex >= 0) {
            status = 'misplaced';
            answerChars[misplacedIndex] = SOLVED_CHAR;
        }

        result[i] = {
            letter: guessChars[i],
            status,
        };
    }

    return result;
}

export const isRealWord = (guess, language) => {
    let dictionary;
    switch (language) {
        case 'EN':
            dictionary = ENGLISH_WORDS;
            break;
        case 'ES':
            dictionary = SPANISH_WORDS;
            break;
        case 'RU':
            dictionary = RUSSIAN_WORDS;
            break;
        default:
            dictionary = ENGLISH_WORDS;
            break;
    }
    return dictionary.find(
        (word) => word.toUpperCase() === guess.toUpperCase()
    );
};
